import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { TransactionComparison } from "../../types/DossierTransaction";

export const getDossierTransactionComparison = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossierTransactionComparison", dossierId],
    queryFn: (): Promise<TransactionComparison[]> => {
      return fetchWithAuth<TransactionComparison[]>(
        "getDossierTransactionComparison",
        dossierId
      );
    },
    enabled: isQueryEnabled(options),
  });
};
